/* ForgeWidget.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Hide, media } from '@atlaskit/primitives/responsive';
import { BodyLarge, ForgeButton, H2 } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _32 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _31 = "._y3gn1h6o{text-align:center}";
const _30 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _29 = "@media not all and (min-width:90rem){._1y8o1ogm{max-width:600px}}";
const _28 = "@media not all and (min-width:64rem){._tl28idpf{padding-top:0}._axwiidpf{padding-right:0}._1hwcidpf{padding-bottom:0}._sp8tidpf{padding-left:0}._8fz6glyw{max-width:none}}";
const _27 = "._1pbykb7n{z-index:1}";
const _26 = "._otyr1epz{margin-bottom:var(--ds-space-1000,5pc)}";
const _25 = "._p12f1c3h{max-width:50pc}";
const _24 = "._1yt4cowg{padding:var(--_vy7ex0)}";
const _23 = "._1xi2idpf{right:0}";
const _22 = "._5ral1f51{object-fit:contain}";
const _21 = "._1ltvidpf{left:0}";
const _20 = "@media not all and (min-width:90rem){._zzrmxoa3{width:32rem}}";
const _19 = "._1pbyidpf{z-index:0}";
const _18 = "._1bsbfxhx{width:37.75rem}";
const _17 = "._94n5ze3t{bottom:var(--ds-space-0,0)}";
const _16 = "._154ize3t{top:var(--ds-space-0,0)}";
const _15 = "._kqswstnw{position:absolute}";
const _14 = "@media (min-width:48rem) and (max-width:63.99rem){._1x6l1mjv{min-height:300px}}";
const _13 = "@media not all and (min-width:48rem){._15txwcbu{padding:var(--_4thsry)}._1rgcr0r7{min-height:250px}}";
const _12 = "._1tke1kdj{min-height:25pc}";
const _11 = "._1bah1h6o{justify-content:center}";
const _10 = "._4cvr1h6o{align-items:center}";
const _9 = "._kqswh2mm{position:relative}";
const _8 = "._p12f18iq{max-width:110rem}";
const _7 = "._1bsb1osq{width:100%}";
const _6 = "._2lx21bp4{flex-direction:column}";
const _5 = "._1e0c1txw{display:flex}";
const _4 = "._18u01wug{margin-left:auto}";
const _3 = "._otyr1wug{margin-bottom:auto}";
const _2 = "._2hwx1wug{margin-right:auto}";
const _ = "._19pk1wug{margin-top:auto}";
const forgeWidgetWrapperStyles = null;
const contentContainerStyles = null;
const headingStyles = null;
const descriptionStyles = null;
const imageContainerBaseStyles = null;
const imageLeftStyles = null;
const imageRightStyles = null;
const imageStyles = null;
export const ForgeWidget = _ref => {
  let {
    heading,
    description,
    buttonLabel,
    buttonHref,
    leftImage,
    rightImage,
    buttonAriaLabel,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _2lx21bp4 _1bsb1osq _p12f18iq _kqswh2mm _4cvr1h6o _1bah1h6o _1tke1kdj _15txwcbu _1rgcr0r7 _1x6l1mjv"]),
      style: {
        "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
      },
      children: [/*#__PURE__*/_jsxs(Hide, {
        below: "md",
        children: [leftImage && /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_15, _16, _17, _18, _5, _10, _19, _20, _21]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_kqswstnw _154ize3t _94n5ze3t _1bsbfxhx _1e0c1txw _4cvr1h6o _1pbyidpf _zzrmxoa3", "_1ltvidpf"]),
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_7, _22]
              }), /*#__PURE__*/_jsx("img", {
                alt: "",
                src: leftImage,
                className: ax(["_1bsb1osq _5ral1f51"])
              })]
            })
          })]
        }), rightImage && /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_15, _16, _17, _18, _5, _10, _19, _20, _23]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_kqswstnw _154ize3t _94n5ze3t _1bsbfxhx _1e0c1txw _4cvr1h6o _1pbyidpf _zzrmxoa3", "_1xi2idpf"]),
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_7, _22]
              }), /*#__PURE__*/_jsx("img", {
                alt: "",
                src: rightImage,
                className: ax(["_1bsb1osq _5ral1f51"])
              })]
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_24, _9, _5, _7, _25, _11, _6, _10, _26, _27, _28, _29]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_1yt4cowg _kqswh2mm _1e0c1txw _1bsb1osq _p12f1c3h _1bah1h6o _2lx21bp4 _4cvr1h6o _otyr1epz _1pbykb7n _tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _8fz6glyw _1y8o1ogm"]),
          style: {
            "--_vy7ex0": ix("0 ".concat("var(--ds-space-300, 24px)", " ", "var(--ds-space-500, 40px)"))
          },
          children: [heading && /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_30, _31]
            }), /*#__PURE__*/_jsx(H2, {
              tabIndex: -1,
              className: ax(["_otyru2gc _y3gn1h6o"]),
              children: heading
            })]
          }), description && /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_31, _32]
            }), /*#__PURE__*/_jsx(BodyLarge, {
              className: ax(["_y3gn1h6o _otyrxy5q"]),
              children: description
            })]
          }), buttonLabel && buttonHref && /*#__PURE__*/_jsx(ForgeButton, {
            href: buttonHref,
            target: "_blank",
            "aria-label": buttonAriaLabel,
            onClick: onClick,
            children: buttonLabel
          })]
        })]
      })]
    })]
  });
};